import { Route } from 'src/routes/Route'

export const CustomCardEditRoute = Route({
  path: '/edit',
  init: () => ({}),
  fromPath: () => ({}),
})
export type CustomCardEditRoute = Route<typeof CustomCardEditRoute>
